import { useParams } from 'react-router-dom'
import InnerBanner from '../../../../components/InnerBanner'
import useResize from '../../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../../utils/constants'
import DashboardWrapper from '../../../Dashboard/components/DashboardWrapper'
import hutrit_club_icon from '../../icons//already_hutrit_club_member_company.svg'
import { useQuery } from '@tanstack/react-query'
import { challengeDetail } from '../../../../services/HutritClub'
import Loader from '../../../../components/Loader'

const ChallengeDetail = () => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const { id } = useParams()

  const { data: challengeDetailData, isLoading: isLoadingChallengeDetail } =
    useQuery(['challenge-detail', id], () => challengeDetail({ id }))

  const { challenge } = challengeDetailData ?? {}

  return (
    <DashboardWrapper dashboardWrapperClassName="w-100 pt-5 mt-5 ">
      <InnerBanner before="Retos Hutrit Club" beforeRoute={-1} text="Empresa" />
      {isLoadingChallengeDetail ? (
        <Loader />
      ) : (
        <div className={`${isMobile ? 'px-2' : ''}`}>
          <div
            className={`${
              isMobile ? 'px-2' : 'px40'
            } border border-illustration rounded py-lg-5 py-2 mt-lg-5 mt-3`}
            style={{
              background: 'rgba(1, 167, 106, 0.05)',
            }}
          >
            <div className="d-flex flex-column align-items-start">
              <div className="d-flex flex-lg-row flex-column align-items-lg-center justify-content-start gap-2 gap-lg-3 mb-2 mb-lg-3">
                <span
                  className={`${
                    isMobile ? 'fontSize20' : 'fontSize32'
                  } fw-bold text-illustration`}
                >
                  {challenge?.name}
                </span>
                <img src={hutrit_club_icon} width={145} />
              </div>
              <span className="fontSize14 text-on-bg-primary">
                Reto para Junior {challenge.category_job?.name}
              </span>
            </div>
            <div className="rounded p-4 bg-white mt-5 d-flex flex-column">
              <span
                className={`${
                  isMobile ? 'fontSize14' : 'fontSize24'
                } text-on-bg-primary fw-bolder`}
              >
                Descripción del reto
              </span>
              <span className="text-on-bg-secondary mt-3">
                {challenge?.description}
              </span>
            </div>
          </div>
        </div>
      )}
    </DashboardWrapper>
  )
}

export default ChallengeDetail
